//Helpers
import { convertUnits, getUnitByRole } from '../template_units_helpers';
//Types
import type {
	TemplateService,
	VirtualComponentInterfaceData,
	VCInterfaceStatus,
} from 'src/types/VirtualComponents';

export const updateNeoWaterValveStatus = (
	interface_data: VCInterfaceStatus[],
	data: VCInterfaceStatus,
	valueData: VirtualComponentInterfaceData,
	templateService: TemplateService,
): void => {
	const { role, config } = data;
	const unit: string = getUnitByRole(role, templateService);
	if (role === 'state') {
		data.hideLabel = true;
		data.label = valueData.value ? 'close' : 'open';
	} else if (role === 'flow_rate') {
		data.min = convertUnits(config.min, role, unit);
		data.max = convertUnits(config.max, role, unit);
	}
	if (unit) {
		const value = /^(water_consumption)$/.test(role)
			? valueData.value?.counter?.total || 0
			: Number(valueData.value) || 0;
		data.rawValue = convertUnits(value, role, unit);
		data.unit = getUnitByRole(role, templateService, true);
		data.value = `${data.rawValue} ${data.unit}`;
	}
	interface_data.push(data);
};
